import {Component, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {User} from '../../Interfaces/User';
import {Customs} from '../../Interfaces/Customs';
import {Subscription, timer} from 'rxjs';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {SelectionModel} from '@angular/cdk/collections';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';


@Component({
  selector: 'app-rpm-inspections',
  templateUrl: './rpm-inspections.component.html',
  styleUrls: ['./rpm-inspections.component.css']
})
export class RpmInspectionsComponent implements OnInit {
  public  myUser: User;
  customsData: MatTableDataSource<Customs>;
  public cColumns: string[];
  public cColumns2: string[];
  public containerNum: string;
  subscription: Subscription;
  subscription2: Subscription;
  private clientRequest: ClientRequest;
  private cusDetails: Customs [] = [];
  private cusDetail: Customs;
  private cusDetailsSelected: Customs [] = [];
  private cusDetailsInput: Customs [] = [];
  private selection: SelectionModel<Customs>;
  private allChecked: boolean = false;
  noneSelected: boolean = false;
  noContainer: boolean = false;
  noContFound: boolean = false;
  showScreen: boolean = true;
  phoneApp: boolean = false;


  @ViewChild(MatSort) set content(sort: MatSort) {
    if (this.customsData != undefined) {
      this.customsData.sort = sort;
    }
  }

  @ViewChild(MatPaginator) set content2(pag: MatPaginator) {
    if (this.customsData != undefined) {
      this.customsData.paginator = pag;
    }
  }

  constructor(fb: UntypedFormBuilder,  private router: Router, private  queryService: QueryService, public myApp:AppComponent,private  globalEventsManager: GlobalEventsManager) {
    this.cColumns = ["check","container", "yard", "area","navisErrors"];
    this.cColumns2 = ["check2","container2", "yard2", "area2"];

    this.myUser = this.myApp.user;
/*
            this.myUser = {} as User;
            this.myUser.active ="Y"
            this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
            this.myUser.address_2 = null
            this.myUser.company_code ="M0995"
            this.myUser.company_name= "MAHER TERMINALS, LLC"
            this.myUser.city= "HOUSTON"
            this.myUser.email_address= null
            this.myUser.fax_number= null
            this.myUser.first_name= "Csp Craig"
            this.myUser.last_name= "Miller"
            this.myUser. maherError= null
            this.myUser.old_password= null
            this.myUser.password= ""
            this.myUser.phone_number= null
            this.myUser.company_scac= null
            this.myUser.state= "TX"
            this.myUser.userMenuReportItemsView= null
            this.myUser.user_gkey= "8237887"
            this.myUser.role= "AGENT"
          //  this.myUser.role= "HAULIER"
            this.myUser.username="CSPCUSTOMS"
            this.myUser.zip="07201"
            this.myUser.canSeeAllData = "0";

 */



  }

  ngOnInit() {
    this.showScreen = true;
    this.cusDetailsSelected = [];

    if (window.innerWidth <= 800){
      this.phoneApp = true;
    }

    if (this.subscription2==null){
      this.subscription2 = timer(0, 30000)
        .subscribe(() => this.getContainers());
      this.globalEventsManager.cusSubscription.emit(this.subscription2);
    }

  }

  refreshScreen(){
    this.getContainers();
  }

  private getContainers(){
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    const lhsUserObs$ = this.queryService.customsGetContainers(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (cus) => {
        this.cusDetails = cus;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);
          this.router.navigate(["login"]);
        } else {
          this.subscription2.unsubscribe();
          this.myApp.openDialog(error.message)
        }
      },
      () => {

          for (var item of this.cusDetails){
            if (item.navisErrors!=null && item.navisErrors.length>0){

            }
          }
          this.customsData = new MatTableDataSource<Customs>(this.cusDetails);
          this.selection = null;
          this.selection = new SelectionModel<Customs>(true);

      });
  }


  customsAddHold(){
    this.noContFound = false;
    this.noContainer = false;
    if (this.containerNum==null) {
      this.noContainer = true;
      return;
    }

    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.cusDetail = {} as Customs;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.cusDetailsInput = [];

    this.cusDetail.container = this.containerNum;
    this.cusDetailsInput.push(this.cusDetail);

    this.clientRequest.requestData = this.cusDetailsInput;
    const lhsUserObs$ = this.queryService.customsAddHold(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (cus) => {
        this.cusDetails = cus;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.subscription2.unsubscribe();
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        for (var dd=0;dd<this.cusDetails.length;dd++){
          if (this.cusDetails[dd].maherError!=null){
            this.noContFound = true;
            this.cusDetails.splice(dd,1);
          }else{
            if (this.cusDetails[dd].navisErrors!=null && this.cusDetails[dd].navisErrors.length>0){

            }
          }
        }
        this.containerNum = null;
        this.customsData = new MatTableDataSource<Customs>(this.cusDetails);
        this.selection = null;
        this.selection = new SelectionModel<Customs>(true);
      });
  }

  leaveScreen(){
    this.showScreen = false;
    this.subscription2.unsubscribe();
    this.myApp.showCharts();
  }

  customsReleaseHold(){
    this.noneSelected = false;
    if (this.selection.selected.length==0) {
      this.noneSelected = true;
      return;
    }
    this.cusDetailsSelected = [];
    for (var items of this.selection.selected){
        this.cusDetailsSelected.push(items);
    }
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = [];
    this.clientRequest.requestData = this.cusDetailsSelected;
    const lhsUserObs$ = this.queryService.customsReleaseHold(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (cus) => {
        this.cusDetails = cus;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.subscription2.unsubscribe();
          this.myApp.openDialog(error.message)
        }
      },
      () => {



        for (var item of this.cusDetails){
          if (item.navisErrors!=null && item.navisErrors.length>0){

          }
        }
        this.customsData = new MatTableDataSource<Customs>(this.cusDetails);
        this.selection = null;
        this.selection = new SelectionModel<Customs>(true);
      });
  }

  masterToggle(rowIn: Customs, selected:boolean) {
    if (!selected){
      this.selection.select(rowIn);
      this.noneSelected = false;
    }else{
      this.selection.deselect(rowIn);
    }
  }

  checkAll(){
    if (!this.allChecked){
      this.noneSelected = false;
      this.customsData.data.forEach(row => {
        this.selection.select(row)
      })
      this.allChecked = true;
    }else{
      this.customsData.data.forEach(row => {
        this.selection.deselect(row)
      })
      this.allChecked = false;
    }
  }





}
